export default {
    downloadApp: "Téléchargez l'application sur le store de votre appareil",
};
